import AppLayout from 'components/layout/layout'
import PageHeader from '../Activity/Headers/PageHeaderActivity'
import { Row, Col, Tabs, Modal } from 'antd'
import { useEffect, useState } from 'react'
import ActionHeader from './Headers/ActionHeader'
import ActivityTable from './Table/ActivityTable'
import Spinner from 'components/Spinner'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getActivity, createActivity, updateActivity, deleteActivity } from 'api/Activity'
import AddActivityForm from 'pages/Modals/Sessions/Activity/AddActivityForm'
const { TabPane } = Tabs
const Activity = () => {
  const queryClient = useQueryClient()
  const [selectedRows, setSelectedRows] = useState([])
  const [activeData, setActiveData] = useState<any[]>([])
  const [hiddenColumns, setHiddenColumns] = useState<any>({
    name: true,
    category: true,
    organization: true,
    action: true,
  })
  const [parms, setParms] = useState<any>({
    page: 1,
    limit: 10,
    status: 'active',
  })
  const [isAddModalVisible, setIsAddModalVisible] = useState(false)
  const [editingActivity, setEditingActivity] = useState<any>(null)
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [activityToDelete, setActivityToDelete] = useState<string | null>(null)

  const { isLoading, data, refetch } = useQuery(['getActivity', parms], () =>
    getActivity(parms),
  )

  const createMutation = useMutation({
    mutationFn: ({ organizationId, payload }: any) => createActivity(organizationId, payload),
    onSuccess: () => {
      refetch()
      setIsAddModalVisible(false)
    },
  })

  const updateMutation = useMutation({
    mutationFn: ({ activityId, payload }: any) => updateActivity(activityId, payload),
    onSuccess: () => {
      refetch()
      setEditingActivity(null)
    },
  })

  const deleteMutation = useMutation({
    mutationFn: (activityId: string) => deleteActivity(activityId),
    onSuccess: () => {
      refetch()
      setDeleteModalVisible(false)
      setActivityToDelete(null)
    },
  })
  const deleteMultipleRecords = () => {
    let _data = [...activeData]
    selectedRows.forEach((row: any) => {
      _data = data.filter(t => t.id !== row.key)
    })
    setActiveData(_data)
    // dispatch({
    //   type: actions.ADD_ORGANIZER,
    //   payload: _data,
    // })
  }
  const handleSearch = (query: string) => {
    setParms({
      ...parms,
      search: query,
    })
  }

  const handleAddActivity = () => {
    setIsAddModalVisible(true)
  }

  const handleEditActivity = (record: any) => {
    setEditingActivity(record)
  }

  const handleDeleteActivity = (activityId: string) => {
    setActivityToDelete(activityId)
    setDeleteModalVisible(true)
  }

  const confirmDelete = () => {
    if (activityToDelete) {
      deleteMutation.mutate(activityToDelete)
    }
  }

  // Restore an archived activity back to active (edit-step1 accepts status).
  const handleRestoreActivity = (activityId: string) => {
    updateMutation.mutate({ activityId, payload: { status: 'active' } })
  }

  const onTabChange = (key: string) => {
    setParms({ ...parms, status: key, page: 1 })
  }

  const tableContent =
    isLoading ? (
      <div
        className="flex justify-center aligin-center items-center "
        style={{ height: '80vh' }}
      >
        <Spinner />
      </div>
    ) : (
      <ActivityTable
        setSelectedRows={setSelectedRows}
        hidCols={hiddenColumns}
        data={data}
        params={parms}
        setParams={setParms}
        deleteMulti={deleteMultipleRecords}
        onEdit={handleEditActivity}
        onDelete={handleDeleteActivity}
        onRestore={handleRestoreActivity}
      />
    )

  return (
    <AppLayout>
      <PageHeader data={data} onAddActivity={handleAddActivity}></PageHeader>
      <Row>
        <Col style={{ width: '100%' }}>
          <ActionHeader
            setCols={setHiddenColumns}
            hidCols={hiddenColumns}
            search={handleSearch}
            parms={parms}
            setParms={setParms}
          />
        </Col>

        <Col style={{ alignItems: 'center', width: '100%' }}>
          <Tabs activeKey={parms.status} onChange={onTabChange}>
            <TabPane tab="Active" key="active">
              {tableContent}
            </TabPane>
            <TabPane tab="Archived" key="archived">
              {tableContent}
            </TabPane>
          </Tabs>
        </Col>
      </Row>

      <Modal
        title="Add New Activity"
        open={isAddModalVisible}
        onCancel={() => setIsAddModalVisible(false)}
        footer={null}
        width={800}
        destroyOnClose
      >
        <AddActivityForm
          loading={createMutation.isLoading}
          onSubmit={({ organizationId, payload }: any) => {
            createMutation.mutate({ organizationId, payload })
          }}
          onCancel={() => setIsAddModalVisible(false)}
        />
      </Modal>

      <Modal
        title="Edit Activity"
        open={!!editingActivity}
        onCancel={() => setEditingActivity(null)}
        footer={null}
        width={800}
        destroyOnClose
      >
        <AddActivityForm
          isEdit
          loading={updateMutation.isLoading}
          initialValues={editingActivity}
          onSubmit={({ payload }: any) => {
            const activityId = editingActivity?._id || editingActivity?.id
            if (activityId) {
              updateMutation.mutate({ activityId, payload })
            }
          }}
          onCancel={() => setEditingActivity(null)}
        />
      </Modal>

      <Modal
        title="Confirm Delete"
        open={deleteModalVisible}
        onOk={confirmDelete}
        onCancel={() => setDeleteModalVisible(false)}
        okButtonProps={{ loading: deleteMutation.isLoading }}
      >
        <p>Are you sure you want to delete this activity?</p>
      </Modal>
    </AppLayout>
  )
}
export default Activity
